export const BillingEvents = {
  IMPRESSIONS: { id: "IMPRESSIONS", name: "Impresiones" }
};
